<template>
  <div class="align-picker">
    <label for="alignement">{{ label }}</label>
    <ul>
      <li v-for="(key, index) in alignements" :key="'align-' + index" @click="onPickItem(key)">
        <i class="material-icons" :class="{'is-selected': value === key}" >{{ getIcon(key) }}</i>
        <span class="align-picker__label">{{ getLabel(key) }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
const iconDef = {
  "t-left": {
    icon: "format_align_left",
    label: "left"
  },
  "t-center": {
    icon: "format_align_center",
    label: "center"
  },
  "t-right": {
    icon: "format_align_right",
    label: "right"
  },
  "t-justify": {
    icon: "format_align_justify",
    label: "justify"
  },
  "h-left": {
    icon: "border_left",
    label: "left"
  },
  "h-center": {
    icon: "border_vertical",
    label: "center"
  },
  "h-right": {
    icon: "border_right",
    label: "right"
  },
  "v-top": {
    icon: "vertical_align_top",
    label: "top"
  },
  "v-center": {
    icon: "vertical_align_center",
    label: "middle"
  },
  "v-bottom": {
    icon: "vertical_align_bottom",
    label: "bottom"
  },
  "h-layout": {
    icon: "more_horiz",
    label: "horizontal"
  },
  "v-layout": {
    icon: "more_vert",
    label: "vertical"
  }
};

export default {
  name: "alignPicker",
  props: ["modelItem", "value", "options", "label"],
  data() {
    return {
      alignements: this.options,
      icons: iconDef
    };
  },
  methods: {
    getIcon(key) {
      let entry = this.icons[key]
      //console.log("getIcon", key, entry)
      return entry ? entry.icon : null
    },
    getLabel(key) {
      let entry = this.icons[key]
      //console.log("getIcon", key, entry)
      return entry ? entry.label : null
    },
    onPickItem(value) {
      //console.log('on pick item', value)
      if (this.modelItem) {
        this.modelItem.value = value
      }
      this.$emit('pick', value)
    }
  }
};
</script>
